module.exports = __webpack_public_path__ + "img/hp.584566b3.jpg";